module.exports = __webpack_public_path__ + "static/media/laurastromboni.34ccc497.svg";